// extracted by mini-css-extract-plugin
module.exports = {"root":"Pagination_root__mdkF9","text":"Pagination_text__15uW5","light":"Pagination_light__3ZGIE"};